import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  styled,
  Fab
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from 'react-router-dom';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import { apigetPublic } from '../../service/api';
import Footer from '../../components/Footer/footer';

const DashboardContainer = styled(Container)(() => ({
  paddingTop: '100px',
  paddingBottom: '50px',
}));

const OfficerCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  boxShadow: theme.shadows[3],
  borderRadius: '16px',
  overflow: 'hidden',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: theme.shadows[6],
  },
}));

const OfficerMedia = styled(CardMedia)(() => ({
  height: 220,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const OfficerLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));

function LoanOfficerDashboard() {
  const [officers, setOfficers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOfficers = async () => {
      const result = await apigetPublic('loanofficer/search');
      if (result?.status === 200 && Array.isArray(result.data?.result)) {
        setOfficers(result.data.result);
      }
      setIsLoading(false);
    };
    fetchOfficers();
  }, []);

  return (
    <>
      <LandingPageNav />
      <Box
        sx={{
          backgroundImage: 'url(/assets/backgroundimageforherobanner.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          pt: 5,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(255,255,255,0.9)',
            minHeight: '100vh',
            zIndex: 1,
            position: 'relative',
          }}
        >
          <DashboardContainer>
            <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
              Loan Officer Dashboard
            </Typography>

            {isLoading ? (
              <Typography align="center">Loading officers...</Typography>
            ) : officers.length > 0 ? (
             <Grid container spacing={4}>
  {officers.map((officer, index) => (
    <Grid item xs={12} sm={6} md={4} key={officer._id || index}>
      <OfficerLink to={`/dashboard/loanofficers/${officer.slug}`}>
        <OfficerCard>
          <OfficerMedia
            image={
              officer.imageUrl?.startsWith('http')
                ? officer.imageUrl
                : officer.imageUrl
                ? `https://${officer.imageUrl.replace(/^https?:\/\//, '')}`
                : `/assets/images/avatars/avatar_${(index % 24) + 1}.jpg`
            }
            title={`${officer.firstName} ${officer.lastName}`}
          />
          <CardContent>
            <Typography variant="h6">
              {officer.firstName} {officer.lastName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {officer.title || 'Loan Officer'}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {officer.email}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {officer.phone}
            </Typography>
          </CardContent>
        </OfficerCard>
      </OfficerLink>
    </Grid>
  ))}
</Grid>

            ) : (
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 4 }}>
                No loan officers found.
              </Typography>
            )}
          </DashboardContainer>

          {/* Floating Create Button */}
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => navigate('/dashboard/createLO')}
            sx={{
              position: 'fixed',
              bottom: 32,
              right: 32,
              backgroundColor: '#1976d2',
              color: '#fff',
              '&:hover': { backgroundColor: '#115293' },
            }}
          >
            <AddIcon />
          </Fab>
        </Box>
      </Box>
      <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
      <Footer />
    </>
  );
}

export default LoanOfficerDashboard;
